const categoryLabels: Record<string, string> = {
  CONTRACTOR: "Prestataire",
  VISITOR: "Visiteur",
  PRESIDENCY_STAFF: "Personnel de la Présidence",
  EXTERNAL_STAFF: "Personnel externe",
  MILITARY: "Militaire",
  SPECIAL: "Spécial",
};

const roleLabels: Record<string, string> = {
  BADGE_SUPERVISOR: "Superviseur badge",
  INSTITUTION_SUPERVISOR: "Superviseur d'organisation",
  BADGE_OPERATOR: "Opérateur badge",
  SENTINEL: "Sentinelle",
  INSTITUTION_OPERATOR: "Opérateur d'organisation",
  MILITARY_SUPERVISOR: "Superviseur militaire",
  EMPLOYEE: "Employé",
  DSI: "DSI",
};

/** UI labels only: callers keep canonical category/role codes and editable reference values. */
export function createPresentationTerminology(isGeneric: boolean) {
  return {
    personCategory(value?: string | null, fallback?: string) {
      const code = value?.trim().toUpperCase();
      if (isGeneric && code === "MILITARY") return "Sécurité";
      if (isGeneric && code === "PRESIDENCY_STAFF") return "Personnel interne";
      return fallback ?? (value ? categoryLabels[code ?? ""] ?? value : "Personne active");
    },
    roleLabel(value?: string | null, fallback?: string) {
      if (isGeneric && value === "MILITARY_SUPERVISOR") return "Superviseur sécurité";
      return fallback ?? roleLabels[value ?? ""] ?? (value || "Utilisateur");
    },
  };
}
